import { Injectable } from '@angular/core';
import { decodeJWT, fetchAuthSession, signOut } from 'aws-amplify/auth';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { FederatedLogin } from 'src/app/services/auth-service/base.token.provider';
import { environment } from 'src/environments/environment';
import { commonTokenProvider } from 'src/main';
import { NGXLogger } from 'ngx-logger';

declare const gapi: any;

@Injectable({
  providedIn: 'root'
})
export class GoogleAuthService {
  constructor(
    private authService: AuthService,
    private logger: NGXLogger
  ) {
  }

  async signIn(idToken: string) {
    try {
      await this.authService.federatedSignIn(
        'google',
        idToken        
      );
    } catch (err) {
      console.error('Federated sign-in failed:', err);
      throw err;
    }
  }

  async signOut(): Promise<void> {
    await this.authService.signOut();
  }
}
